import { POST_STATEROOM_DATA, SET_GUEST_INFO, GET_STATEROOM_CAPACITY, POST_STATEROOM_STATUS, GET_STATEROOM_CATEGORY, GET_GUEST_TYPE, POST_STATEROOM_SEARCH_DATA, POST_STATEROOM_FILTER_DATA } from './../constants/actionTypes'

export const postStateroomDataAction = data => dispatch => {
  dispatch({
    type: POST_STATEROOM_DATA,
    data
  })
}
export const getGuestTypeDataAction = data => dispatch => {
  dispatch({
    type: GET_GUEST_TYPE,
    data
  })
}

export const setGuestInfoAction = data => dispatch => {
  dispatch({
    type: SET_GUEST_INFO,
    data
  })
}
export const postStateroomSearchDataAction = data => dispatch => {
  dispatch({
    type: POST_STATEROOM_SEARCH_DATA,
    data
  })
}
export const postStateroomFilterDataAction = data => dispatch => {
  dispatch({
    type: POST_STATEROOM_FILTER_DATA,
    data
  })
}


export const getStateroomCategoryAction = data => dispatch => {
  dispatch({
    type: GET_STATEROOM_CATEGORY,
    data
  })
}

export const getStateroomCapacityAction = data => dispatch => {
  dispatch({
    type: GET_STATEROOM_CAPACITY,
    data
  })
}

export const postStateroomStatusDataAction = data => dispatch => {
  dispatch({
    type: POST_STATEROOM_STATUS,
    data
  })
}

